import { useState, useEffect } from 'react';

// Ambang batas standar untuk dianggap sebagai mobile (lebar tablet potret ke bawah)
const MOBILE_BREAKPOINT = 768;

/**
 * Custom hook untuk mendeteksi apakah viewport saat ini berada di bawah
 * ambang batas mobile. Mengembalikan boolean `isMobile`.
 */
export const useViewport = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < MOBILE_BREAKPOINT);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup function untuk menghapus event listener
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []); // Array dependensi kosong memastikan efek ini hanya berjalan sekali

    return { isMobile };
};